import React from 'react';

const ORDER = ['accept', 'clarify', 'decline'];
const COLORS = { accept: '#10b981', clarify: '#f59e0b', decline: '#ef4444' };
const LABELS = { accept: 'Accept', clarify: 'Clarify', decline: 'Decline' };

export default function RecommendationFunnel({ openByRecommendation = {} }) {
    const max = Math.max(1, ...ORDER.map((k) => openByRecommendation[k] || 0));
    return (
        <section className="dashboard-section">
            <h3>Open by recommendation</h3>
            <div className="dashboard-bar-list">
                {ORDER.map((k) => {
                    const n = openByRecommendation[k] || 0;
                    return (
                        <div key={k} className="dashboard-bar">
                            <div
                                className="dashboard-bar-fill"
                                style={{ width: `${(n / max) * 100}%`, background: COLORS[k] }}
                            />
                            <span className="dashboard-bar-label">{LABELS[k]} · {n}</span>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
